import { render, staticRenderFns } from "./CoopDashboard.vue?vue&type=template&id=e1f63d58&scoped=true&"
import script from "./CoopDashboard.vue?vue&type=script&lang=js&"
export * from "./CoopDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f63d58",
  null
  
)

export default component.exports